'use strict';

angular.module('atex.dam').controller('DamPreviewController', [ '$rootScope', '$scope', '$sce', 'DamService',
  'DamPreviewModalController', '$translate', '$modal', '$q', 'ContentService', '$state', '$stateParams',
  'CollectionService', 'DamTemplateService', 'PreviousState', '$timeout', 'DamListService', 'UIConfigurationService',
function($rootScope, $scope, $sce, DamService,
         DamPreviewModalController, $translate, $modal, $q, ContentService, $state, $stateParams, CollectionService,
         DamTemplateService, PreviousState, $timeout, DamListService, UIConfigurationService) {
  $scope.isVideo = undefined;
  $scope.collections = [];
  $scope.parentsIds = [];
  $scope.jobs = [];
  $scope.currentEntry = undefined;
  $scope.showSpinner = false;
  $scope.entry = {};
  $scope.publevents = [];
  $scope.engagementAspect = undefined;
  $scope.originalContent = undefined;
  $scope.images = [];
  $scope.loaded = false;
  $scope.showSpinner = false;
  $scope.onecmsTemplate = undefined;
  $scope.anchorPreview = false;
  $scope.dateFormat = "yyyy-MM-dd";

  UIConfigurationService.getSearchOptions().then(function (options) {
    var dateFormatValue = atex.onecms.ObjectUtils.getByPath(options, 'dateFormatPreview') || "";
    if (dateFormatValue !== ""){
      $scope.dateFormat = dateFormatValue;
    }
  });

  $scope.getDatePreviewFormatted = function(val) {
    if(val){
      if ($scope.dateFormat !== undefined){
        return moment(parseInt(val)).utc().format($scope.dateFormat.toUpperCase());
      }else{
        return moment(parseInt(val)).format("DD-MM-YYYY");
      }
    }
    return "";
  };

  $scope.pageList = []; // it's the list of logical pages contained in a physical page


  $translate(['_IMAGE_PREVIEW_', '_CLOSE_BUTTON_']).then(function (translations) {
    $scope.message = {};

    $scope.message.preview = translations._IMAGE_PREVIEW_;
    $scope.message.close = translations._CLOSE_BUTTON_;
  });

  $scope.back = function() {
    PreviousState.goToLastState();
  };

  function resetPanel() {
    $scope.url = undefined;
    $scope.currentUrl = undefined;
    $scope.currentWebmUrl = undefined;
    $scope.currentMp4Url = undefined;
    $scope.entry = {};
    $scope.publevents = [];
    $scope.id = undefined;
    $scope.showSpinner = false;
    $scope.isVideo = undefined;
    $scope.currentEntry = undefined;
    $scope.collections = [];
    $scope.parentsIds = [];
    $scope.jobs = [];
    $scope.engagementAspect = undefined;
    $scope.originalContent = undefined;
    $scope.images=[];
    $scope.loaded = false;
    $scope.onecmsTemplate = undefined;
    $scope.collectionCrops = undefined;
    $scope.activeView = 0;
    $scope.pageList = [];
  }

  function addPublEventId(publevent) {
    var id = "desk.pe";
    id += ":";
    id += publevent.publication ? publevent.publication : "";
    id += ":";
    id += publevent.edition ? publevent.edition : "";
    id += ":";
    id += publevent.page ? publevent.page : "";
    id += ":";
    id += publevent.section ? publevent.section : "";
    id += ":";
    id += publevent.pubdate ? publevent.pubdate : "";
    id += ":";
    id += publevent.zone ? publevent.zone : "";
    if ( publevent.docId ) {
      id += ":";
      id += publevent.docId ? publevent.docId : "";
    }
    publevent.contentId = id;
  }

  function fillArrays(data) {
    atex.dam.AngularUtils.fixUrls(data);
    $scope.currentMp4Url = $sce.trustAsResourceUrl(data.aspects.contentData.data.mp4Url);
    $scope.currentWebmUrl = $sce.trustAsResourceUrl(data.aspects.contentData.data.webmUrl);

    setEngagementAspect(data);
    setOriginalContentAspect(data);
    setStoryId(data);
    setJobs(data);
    if ($scope.publevents) {
      $scope.publevents.length = 0;
    }

    if ($scope.pageList) {
      $scope.pageList.length = 0;
    }

    for ( var index in data.aspects.contentData.data) {
      if (typeof data.aspects.contentData.data[index] === 'string') {
        $scope.entry.data.aspects.contentData.data[index] = data.aspects.contentData.data[index];
      }else if (data.aspects.contentData.data[index].text) {
        $scope.entry.data.aspects.contentData.data[index].text = data.aspects.contentData.data[index].text;
      }
    }

    if (data.aspects['atex.dam.standard.Publevents'] && data.aspects['atex.dam.standard.Publevents'].data.publevents.length>0) {
      data.aspects['atex.dam.standard.Publevents'].data.publevents.forEach(function(publevent) {
        if (!publevent.contentId || !(new RegExp("desk.pe.").test(publevent.contentId))) {
            // If we don't have a page id into the publevent then create a desk.pe id to use into DamPageViewerController
          addPublEventId(publevent);
        }

        if ( publevent && publevent.pending && _.isEmpty( publevent.docId ) ) {
          publevent.noOpen = true;
        }

        $scope.publevents.push(publevent);
      });
    }

    if (data.aspects['atex.print.Page'] && data.aspects['atex.print.Page'].data.pages.length>0) {
      data.aspects['atex.print.Page'].data.pages.forEach(function(logpage) {
        if( logpage.contentId !== undefined )
        {
          logpage.contentId = removePrefix(logpage.contentId);
        }
        $scope.pageList.push(logpage);
      });
    }


  }
 
  function removePrefix (contentId) {
    if (contentId.startsWith('contentid/')) {
      contentId = contentId.replace('contentid/', '');
    }
    return contentId;
  }

  function setStoryId(data) {
    function hasEntries(attr) {
      return attr && attr.length>0;
    }

    $scope.parentsIds = [];
    if( hasEntries(data.aspects.contentData.data.resources) || hasEntries(data.aspects.contentData.data.images) ){
  	  $scope.parentsIds.push($scope.id);
  	} else {
  	  DamService.loadReferences(atex.dam.AngularUtils.addPrefix($scope.id)).then(function(data) {
  	    if(data.references) {
  		  if( angular.isArray(data.references)) {
  	        data.references.forEach(function(reference) {
  		      $scope.parentsIds.push(reference);
  		    });
  	      } else {
  	        $scope.parentsIds.push(data.references);
  	      }
  	    }
  	  });
    }
  }

  function setJobs(data) {
    $scope.jobs = [];
    if( (data.aspects.contentData.data.tasks) && (data.aspects.contentData.data.tasks.length>0) ) {
      $scope.jobs.push(createJob($scope.id,data.aspects.contentData.data.name));
    } else {
      DamService.loadJobs(atex.dam.AngularUtils.addPrefix($scope.id)).then(function (data) {
        $scope.getJobs(data.references).then(function(result) {
          $scope.jobs = result.slice();
        });
      });
    }
  }

  function createJob(id,name) {
    return { id: id, name: name };
  }

  $scope.createJob = function(id) {
    var deferred = $q.defer();

    ContentService.getContent({id:id}).then(function(response) {
      var job = {
        id: id,
        name: response.data.aspects.contentData.data.name
      };

      deferred.resolve(job);
    }).then(null,function(error) {
      deferred.reject(error);
    });

    return deferred.promise;
  };

  $scope.getJobs = function(contents) {
    var references = [];
    if(!angular.isArray(contents))  {
      if(contents) {
        references.push(contents);
      }
    } else {
      references = contents.slice();
    }

    var deferred = $q.defer();

    var promises = references.map(function (reference) {
      return $scope.createJob(reference);
    });

    $q.all(promises).then(function (objects) {
      deferred.resolve(objects);
    });

    return deferred.promise;
  };

  function setEngagementAspect(data) {
    if( ( data !== undefined ) && ( data.aspects !== undefined ) && ( data.aspects.engagementAspect !== undefined ) ) {
      DamService.getUserDomains().then(function(domain) {
        $scope.engagementAspect = data.aspects.engagementAspect;
        if (domain && domain.exportSites && domain.exportSites.length > 0) {
          // Filter by domain
          $scope.engagementAspect.data.engagementList = data.aspects.engagementAspect.data.engagementList.filter(function(eng) {
            var domainFound = _.find(domain.exportSites, function (exportSite) {
              // Show the engagement if
              // 1. domain is one of my domains
              // 2. the engagement has no domain (is old) AND:
              //  2.1 is a web engage
              //  2.2 is NOT a web engage and my domain is the default domain dam.assets.d (old content without domain in db)
              return exportSite.extId === eng.domain ||
                    (!eng.domain && eng.appType === 'atex.dm.polopoly') ||
                    (!eng.domain && eng.appType !== 'atex.dm.polopoly' && exportSite.extId === 'dam.assets.d');
            });
            return domainFound;
          });
        }
      });
    } else {
      $scope.engagementAspect = undefined;
    }
  }

  function setOriginalContentAspect(data) {
    if( ( data !== undefined ) && ( data.aspects !== undefined ) && ( data.aspects['atex.original.content'] !== undefined ) ) {
      $scope.originalContent = data.aspects['atex.original.content'];
    } else {
      $scope.originalContent = undefined;
    }
  }

  var setupCollectionImgs = function(data) {
    if ( data.aspects.contentData.data.objectType === "collection" ) {
      CollectionService.getCollection(data.version).then(function(collection) {
        CollectionService.getAllCollectionItems(collection).then(function(collectionItems) {
          $scope.images=[];
          collectionItems.forEach(function(content) {
            if (content.isForbidden && content.dontShow) {
              return;
            }
            if (content.data.aspects.contentData.data.thumbUrl) {
              var img = {};
              img.url = content.data.aspects.contentData.data.thumbUrl;
              img.caption=content.data.aspects.contentData.data.caption;
              $scope.images.push(img);
            }
          });
        }).then(null, function(error) {
          console.log('Error while loading collection items!', error);
        });
      }).then(null, function(error) {
        console.log('Error while loading collection!', error);
      });
    }
  };

  var fixCurrentUrl = function(contentData) {
    if (contentData.data.objectType === "image") {
      $scope.currentUrl = contentData.data.lowUrl;
      $scope.url = contentData.data.url;
    } else if (contentData.data.objectType === "page") {
      $scope.currentUrl = contentData.data.thumbUrl;
      $scope.url = $scope.currentUrl;
    } else if (contentData.data.objectType === "graphic") {
      $scope.currentUrl = contentData.data.thumbUrl;
      $scope.url = $scope.currentUrl;
    } else if (contentData.data.objectType === "tweet") {
      $scope.currentUrl = contentData.data.thumbUrl;
      $scope.url = $scope.currentUrl;
    } else if (contentData.data.objectType === "instagram" && !contentData.data.standardVideoUrl) {
      $scope.currentUrl = contentData.data.url;
      $scope.url = $scope.currentUrl;
    }
  };

  var setVersion = function(data, isVersion ) {
    if (data.aspects['atex.print.Page']) {
      if ( typeof data.aspects['atex.print.Page'].data === 'undefined' && isVersion ) {
        data.aspects['atex.print.Page'].data = {};
      }

      var printPage = data.aspects['atex.print.Page'].data;

      if ( printPage ) {
        printPage.isVersion = isVersion;
      }
    }
  };

  function getHighLightedEntry(contentId, searchString) {
    $scope.isVideo = undefined;
    DamService.getHighLightedEntry(contentId, searchString).then(function (objComplete) {

      // If we are previewing an item into the collection editor view
      // and we have custom crops, use it as 'atex.ImageEditInfo' [max]
      if ($scope.collectionCrops) {
        var currentImageEditInfo = objComplete.data.aspects['atex.ImageEditInfo'];
        if (!currentImageEditInfo) {
          currentImageEditInfo = objComplete.data.aspects['atex.ImageEditInfo'] = {};
        }
        // Set the atex.ImageEditInfo as the equivalent into atex.collection
        currentImageEditInfo.data = angular.copy($scope.collectionCrops);
        currentImageEditInfo.data._type = "atex.ImageEditInfo";
      }

      atex.dam.AngularUtils.fixUrls(objComplete.data);
      setVersion(objComplete.data, false);
      fixCurrentUrl(objComplete.data.aspects.contentData);
      setupCollectionImgs(objComplete.data);
      var templateId = objComplete.data.aspects.contentData.data._type;
      templateId += ".dam.preview";
      var inputTemplate = objComplete.data.aspects.contentData.data.inputTemplate;
      DamTemplateService.getTemplateByIdAndInputTemplate(templateId, inputTemplate).then(function (template) {
        if (!template) {
          if (console.log) {
            console.log('Template with id ' + templateId + ' has not been found');
          }
        }
        $scope.onecmsTemplate = template;
        $scope.isVideo = atex.dam.AngularUtils.hasVideo(objComplete.data);
        angular.copy(objComplete, $scope.entry);
        fillArrays(objComplete.data);
        $scope.currentEntry = objComplete;

        if (!$scope.onecmsTemplate) {
          $scope.showSpinner = false;
        } else {
          $scope.loaded = true;
        }
      }).then(null, function (error) {
        $scope.showSpinner = false;
        console.log('ERROR: getHighLightedEntry:', error);
      });
    }).then(null, function (error) {
      $scope.showSpinner = false;
      console.log('ERROR: getHighLightedEntry:', error);
    });
  }

  // Handle login / logout
  $scope.$on("dam:logout", function() {
    if ( !$scope.anchorPreview ) {
      resetPanel();
    }
  });

  $scope.$on("dam:initSearch", function() {
    if ( !$scope.anchorPreview ) {
      resetPanel();
    }
  });

  $scope.$on("dam:clearPreviewPanel", function() {
    if ( !$scope.anchorPreview ) {
      resetPanel();
    }
  });

  $scope.$on('dam:anchorPreview', function( event, anchorModule, anchorPreview, anchorData ) {
    $scope.anchorModule = anchorModule;
    $scope.anchorPreview = anchorPreview;

    if ( anchorPreview ) {
      $scope.anchorData = anchorData;
      DamListService.setAnchor( anchorData );
    } else {
      delete $scope.anchorData;
      DamListService.clearAnchor();
    }
  });

  $scope.$on("dam:setAnchoredPreview", function( event, anchorModule, anchorPreview, contentId ) {
    if ( contentId !== $scope.id ) {
      resetPanel();

      $rootScope.$broadcast( "dam:anchorPreview", anchorModule, false );
      $timeout(function() {
        if (contentId !== undefined) {
          $scope.setPreviewingItemById(contentId, false);
        }

        var anchorData = {
          contentId: contentId
        };
        $rootScope.$broadcast( "dam:anchorPreview", anchorModule, true, anchorData );
      }, 2000 );

    }
  });

  var loadAdditionalInfo = function() {
    DamService.getCollections($scope.id).then(function(response) {
      if (response && response.data && response.data.response && response.data.response.docs) {
        response.data.response.docs.forEach(function(collection) {
          var currCollection = {};
          currCollection.id = collection.id;
          currCollection.name = collection.name_atex_desk_ts;
          $scope.collections.push(currCollection);
        });
      }
    });
  };

  var loadById = function(versionedId) {
    getHighLightedEntry(versionedId, $rootScope.lastSearch);
    loadAdditionalInfo();
  };

  var loadVersion = function(versionedId) {
    ContentService.getContent({id: versionedId}).then(function(objComplete) {
      atex.dam.AngularUtils.fixUrls(objComplete.data);
      setVersion(objComplete.data, true);
      fixCurrentUrl(objComplete.data.aspects.contentData);
      setupCollectionImgs(objComplete.data);
      var templateId = objComplete.data.aspects.contentData.data._type;
      templateId += ".dam.preview";
      var inputTemplate = objComplete.data.aspects.contentData.data.inputTemplate;
      DamTemplateService.getTemplateByIdAndInputTemplate(templateId, inputTemplate).then(function(template){
        $scope.onecmsTemplate = template;
        $scope.isVideo = atex.dam.AngularUtils.hasVideo(objComplete.data);
        angular.copy(objComplete, $scope.entry);
        fillArrays(objComplete.data);
        $scope.currentEntry = objComplete.data;
        if (!$scope.onecmsTemplate) {
          $scope.showSpinner = false;
        } else {
          $scope.loaded = true;
        }
      }).then(null, function(error) {
        $scope.showSpinner = false;
        console.log('ERROR: loadVersion:', error);
      });
    }).then(null, function(error) {
      $scope.showSpinner = false;
      console.log('ERROR: loadVersion:', error);
    });
  };

  var timer;

  function getCollectionCrops(item) {
    // Check if the item has atex.collection aspect
    // (that holds custom fields and crop for collections where it belongs)
    // and in case replace the atex.ImageEditInfo of the item
    // with the one form the atex.collection aspect [max]
    var collections = atex.onecms.ObjectUtils.getByPath(item, ['data', 'aspects', 'atex.collection', 'data', 'collections']);
    if (collections) {
      var currentCollection;
      collections.forEach(function(tmp) {
        if( tmp.contentId === $stateParams.id ) {
          // We found the atex.collection aspect suitable for the current editing collection
          currentCollection = tmp;
        }
      });
      if (currentCollection && currentCollection.crop) {
        $scope.collectionCrops = angular.copy(currentCollection.crop);
      }
    }
  }

  function setPreviewingItem(data) {
    if ( !$scope.anchorPreview ) {
      resetPanel();
      if (data !== undefined) {
        $scope.showSpinner = true;
        if (!data.versionInfo) {
          $scope.id = data.id;
          fixCurrentUrl(data._data.aspects.contentData);
          getCollectionCrops(data);
          loadById($scope.id);
        } else {
          // Is a version content, coming from dam-versions
          // see DamVersionsController.collectVersions
          $scope.id = data.versionInfo.version;
          loadVersion($scope.id);
        }
      }
    }
  }

  $scope.$on("dam:setPreviewingItem", function(event, data, arrowKeys) {
    if (arrowKeys) {
      if (timer) {
        $timeout.cancel(timer);
      }
      timer = $timeout(function () {
        setPreviewingItem(data);
      }, 1000);
    } else {
      setPreviewingItem(data);
    }
  });

  $scope.$on("activePreview:planPage", function(event, module, contentId) {
    if ( contentId !== $scope.id ) {
      resetPanel();

      if (contentId !== undefined) {
        $scope.setPreviewingItemById(contentId, false);
      }
    }
  });

  $scope.setPreviewingItemById = function(contentId, version) {
    $scope.showSpinner = true;

    if (!version) {
      ContentService.getContent({id : contentId}).then(function(response) {
        $scope.id = response.id;
        loadById(response.id);
      });
    } else {
      $scope.id = version;
      loadVersion($scope.id);
    }
  };

  $scope.$on("dam:updatedItem", function(event, asset) {
    if (!$scope.id || !asset || !asset.id) {
      return;
    }
    if ($scope.id === asset.id) {
      ContentService.getContent({
        id : $scope.id
      }).then(function(response) {
        fillArrays(response.data);
        if (response.data.aspects.contentData.data.objectType === "image") {
          $scope.currentUrl = response.data.aspects.contentData.data.lowUrl;
          $scope.url = response.data.aspects.contentData.data.url;
        }
      });
    }
  });

  $scope.to_trusted = function(html_code) {
    if (html_code !== undefined) {
      return $sce.trustAsHtml(html_code);
    }
  };

  $scope.open = function(url) {
    var confirmModal = DamPreviewModalController.create({
      'header' : $scope.message.preview,
      'close' : $scope.message.close,
      'url' : url,
      'thumbUrl' : $scope.currentEntry._data.aspects.contentData.data.thumbUrl,
      'inputTemplate' : $scope.currentEntry._data.aspects.contentData.data.inputTemplate,
    });
  };

  $scope.showPage = function(publevent) {
    if (!publevent ) {
      console.log("ERROR: showPage received a null publevent!");
      return;
    }

    if ( publevent.noOpen ) {
      return;
    }

    if( publevent.contentId === undefined ){
      console.log("ERROR: showPage publevent.contentId undefined!");
      return;
    }

    $state.go('list.page', { 'id' : publevent.contentId });
  };

  

  $scope.loadCollection = function(id) {
    $state.go('list.collection', { 'id' : id, 'preview': 'preview' });
  };

  $scope.showReferences = function(parentId) {
    if (parentId) {
      $state.go('list.relations', { 'id' : parentId });
    }
  };

  $scope.showRelated = function(contentId) {
    var references = [];
    if(angular.isArray(contentId)) {
      references = contentId.slice();
    } else {
      references.push(contentId);
    }
    $state.go('list.related', { 'references' : references });
  };

  $scope.showJobs = function(parentId) {
    if (parentId) {
      $state.go('list.jobs', { 'id' : parentId });
    }
  };

  $scope.$on("dam:itemDeleted", function(event, contentId) {
    if ($scope.id === contentId) {
      resetPanel();
    }
  });

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
  };

  if ($stateParams.id) {
    // Load
    $scope.setPreviewingItemById($stateParams.id, $stateParams.version);
  }

  $scope.updateActiveView = function(index) {
    $scope.activeView = index;
  };

} ]);

angular.module('atex.dam').directive('damPreview', function() {
  return {
    restrict : 'EA',
    templateUrl : 'views/dam-preview/dam-preview.html',

    scope : true,

    controller : 'DamPreviewController',

    link : function(scope, element, attrs) {
      if (attrs.id) {
        scope.setPreviewingItemById(attrs.id);
      }
    }

  };
});


